import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { ActionReducer, META_REDUCERS, MetaReducer } from '@ngrx/store';
import {
  CART_MODIFICATION_NORMALIZER,
  CART_NORMALIZER,
  OccCartModificationNormalizer,
  OccCartNormalizer,
} from './converters';
import { ActiveCartService, CartStateSnapshotService, CustomActiveCartService } from './facade';
import { CartStoreModule } from './store';

/**
 * Before `MultiCartStatePersistenceService` restores the active cart id `ActiveCartService`
 * will use `current` cart instead of the one saved in browser. This meta reducer
 * sets the value on store initialization to null cart which holds active cart loading
 * until the data from storage is restored.
 */
export function uninitializeActiveCartMetaReducerFactory(): MetaReducer<any> {
  const metaReducer: MetaReducer<any> = (reducer: ActionReducer<any>) => (state: any, action: any) => {
    const newState = { ...state };
    if (action.type === '@ngrx/store/init') {
      newState.cart = {
        ...newState.cart,
        ...{ active: null },
      };
    }

    return reducer(newState, action);
  };

  return metaReducer;
}

export function initCartSnapshot(injector: Injector): () => void {
  return () => {
    const cartStateSnapshotInstance = injector.get(CartStateSnapshotService);

    cartStateSnapshotInstance.initCartSnapshotService();
  };
}

@NgModule({
  imports: [CartStoreModule],
  providers: [
    {
      provide: CART_NORMALIZER,
      useExisting: OccCartNormalizer,
      multi: true,
    },
    {
      provide: CART_MODIFICATION_NORMALIZER,
      useExisting: OccCartModificationNormalizer,
      multi: true,
    },
    {
      provide: META_REDUCERS,
      useFactory: uninitializeActiveCartMetaReducerFactory,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = initCartSnapshot(inject(Injector));

      return initializerFn();
    }),
    { provide: ActiveCartService, useExisting: CustomActiveCartService },
  ],
})
export class CartDataAccessModule {}
